import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { MODULE_TYPES } from 'ohif-core';
import OHIF from 'ohif-core';
import moment from 'moment';

import ConnectedToolbarRow from './ConnectedToolbarRow.js';
import ConnectedLabellingOverlay from './ConnectedLabellingOverlay';
import ConnectedViewerMain from './ConnectedViewerMain.js';
import SidePanel from './../components/SidePanel.js';
import { extensionManager } from './../App.js';
import ConnectedHeatmapLoader from './ConnectedHeatmapLoader';
import './Viewer.css';
import { apis } from '../api/index.js';
import qs from 'query-string';
import { Radio, message } from 'antd';
import { eventListener } from '../utils/helpers.js';

class Viewer extends Component {
  static defaultProps = {
    followupLen: 0,
    userInfo: {},
  };
  static propTypes = {
    studies: PropTypes.array,
    studyInstanceUids: PropTypes.array,
    onTimepointsUpdated: PropTypes.func,
    onMeasurementsUpdated: PropTypes.func,
    viewports: PropTypes.object.isRequired,
    activeViewportIndex: PropTypes.number.isRequired,
    showCharts: PropTypes.bool.isRequired,
    setViewportSpecificData: PropTypes.func.isRequired,
    setHeatmapDataSource: PropTypes.func,
    resource: PropTypes.object,
    history: PropTypes.object,
    setHeatmapData: PropTypes.func.isRequired,
    onUserInfoUpdated: PropTypes.func,
    userInfo: PropTypes.object,
    setAiProductHeatmapData: PropTypes.func,
    aiProductDetailInfo: PropTypes.array,
    detailList4StudyImgList: PropTypes.array,
    tubeStudyDetail: PropTypes.object,
    applicationInfo: PropTypes.object,
    followupVisibleCallBack: PropTypes.func,
    followupList: PropTypes.array,
    followupLen: PropTypes.number,
    dicomInfoBy3Uid: PropTypes.object,
    setApplicationData: PropTypes.func,
  };
  constructor(props) {
    super(props);
    OHIF.measurements.MeasurementApi.setConfiguration({
      dataExchange: {
        retrieve: this.retrieveMeasurements,
        store: this.storeMeasurements,
      },
    });

    OHIF.measurements.TimepointApi.setConfiguration({
      dataExchange: {
        retrieve: this.retrieveTimepoints,
        store: this.storeTimepoints,
        remove: this.removeTimepoint,
        update: this.updateTimepoint,
        disassociate: this.disassociateStudy,
      },
    });

    const search = qs.parse(window.location.search);
    this.state = {
      ...search,
      isLeftSidePanelOpen: true,
      isRightSidePanelOpen: !!search.type, //this.props.showCharts,
      rightSidePanelDisabled: false,
      selectedRightSidePanel: 'charts-panel',
      selectedLeftSidePanel: 'studies-panel', // TODO: Don't hardcode this
      thumbnails: [],
      aiReport: {},
      dicomIds: [],
      selectedData: [],
      showScreening: true,
      value: '',
      isChest: false,
      followupVisible: false,
      followupLen: 0,
      applicationInfo: {},
    };
  }

  retrieveMeasurements = (patientId, timepointIds) => {
    // OHIF.log.info('retrieveMeasurements');
    // TODO: Retrieve the measurements from the latest available SR
    return Promise.resolve();
  };

  storeMeasurements = (measurementData, timepointIds) => {
    // OHIF.log.info('storeMeasurements');
    // TODO: Store the measurements into a new SR sent to the active server
    return Promise.resolve();
  };

  retrieveTimepoints = filter => {
    // OHIF.log.info('retrieveTimepoints');

    // Get the earliest and latest study date
    let earliestDate = new Date().toISOString();
    let latestDate = new Date().toISOString();
    if (this.props.studies) {
      latestDate = new Date('1000-01-01').toISOString();
      this.props.studies.forEach(study => {
        const studyDate = moment(study.studyDate, 'YYYYMMDD').toISOString();
        if (studyDate < earliestDate) earliestDate = studyDate;

        if (studyDate > latestDate) latestDate = studyDate;
      });
    }

    // Return a generic timepoint
    return Promise.resolve([
      {
        timepointType: 'baseline',
        timepointId: 'TimepointId',
        studyInstanceUids: this.props.studyInstanceUids,
        patientId: filter.patientId,
        earliestDate,
        latestDate,
        isLocked: false,
      },
    ]);
  };

  storeTimepoints = timepointData => {
    OHIF.log.info('storeTimepoints');
    return Promise.resolve();
  };

  updateTimepoint = (timepointData, query) => {
    OHIF.log.info('updateTimepoint');
    return Promise.resolve();
  };

  removeTimepoint = timepointId => {
    OHIF.log.info('removeTimepoint');
    return Promise.resolve();
  };

  disassociateStudy = (timepointIds, studyInstanceUid) => {
    OHIF.log.info('disassociateStudy');
    return Promise.resolve();
  };

  onTimepointsUpdated = timepoints => {
    if (this.props.onTimepointsUpdated) {
      this.props.onTimepointsUpdated(timepoints);
    }
  };

  onMeasurementsUpdated = measurements => {
    if (this.props.onMeasurementsUpdated) {
      this.props.onMeasurementsUpdated(measurements);
    }
  };

  async componentDidMount() {
    if (document.addEventListener) {
      const [productionId, pageId] = ['101', '10022'];
      document.addEventListener('webkitvisibilitychange', function() {
        const eventData = { productionId, pageId, moduleId: 'mk0003' };
        let elementId;
        if (document.webkitVisibilityState === 'visible') elementId = 'ns-002';
        else if (document.webkitVisibilityState === 'hidden')
          elementId = 'ns-001';
        eventListener({ ...eventData, elementId });
      });
    }

    if (this.props.dicomInfoBy3Uid)
      this.props.setApplicationData(this.props.dicomInfoBy3Uid);
    this.props.setHeatmapData({ type: 'clear' });
    const { from, from1, type, isOtherBody } = this.state;
    let showAiReport = !!type || from1 === 'aireport' || from === 'screening';
    if (isOtherBody === 'true') showAiReport = false;

    let rightSidePanelDisabled = showAiReport ? false : true;
    this.setState({
      thumbIndex: 0,
      isRightSidePanelOpen: showAiReport,
      rightSidePanelDisabled,
    });
    this.props.setHeatmapDataSource(this.props.resource);

    const { TimepointApi, MeasurementApi } = OHIF.measurements;
    const currentTimepointId = 'TimepointId';

    const timepointApi = new TimepointApi(currentTimepointId, {
      onTimepointsUpdated: this.onTimepointsUpdated,
    });

    const measurementApi = new MeasurementApi(timepointApi, {
      onMeasurementsUpdated: this.onMeasurementsUpdated,
    });

    this.currentTimepointId = currentTimepointId;
    this.timepointApi = timepointApi;
    this.measurementApi = measurementApi;

    const { studies } = this.props;
    if (studies) {
      const patientId = studies[0] && studies[0].patientId;

      timepointApi.retrieveTimepoints({ patientId });
      measurementApi.retrieveMeasurements(patientId, [currentTimepointId]);
      this.setState({ thumbnails: _mapStudiesToThumbnails(studies) });
    }
    if (from === 'aiproduct') {
      const pathname = window.location.pathname;
      const { from, from1, id } = this.state;
      this.setAIProductRightPanel(() => {
        if (pathname.includes('/heatmap') && from === 'aireview') {
          this.dcmQc(id);
        } else if (
          pathname.includes('/viewer/study') &&
          (from1 === 'aireview' || from1 === 'review')
        ) {
          if (this.state.applyImages) {
            this.dcmQc(this.state.applyImages[0].dicomDrId);
          }
        }
      });
    }
  }

  changeAiResult = item => {
    const { type } = this.state;
    const post = {
      study_uid: item.studyInstanceUid,
      series_uid: item.seriesInstanceUid,
      sop_instance_uid: item.images[0].sopInstanceUID,
      aiProductType: type,
    };
    apis.getAiResult(post).then(res => {
      if (res.code === '0') {
        this.props.setHeatmapDataSource(res.data);
      } else if (res.code === '1009') {
        this.props.history.push('/login');
      }
    });
  };

  onThumbnailClick = item => {
    const [productionId, pageId] = ['101', '10022'];
    const [moduleId, elementId] = ['mk0001', 'ns-022'];
    eventListener({ productionId, pageId, moduleId, elementId });

    const { from, from1, id } = this.state;
    const { applyImages } = this.state;
    const pathname = window.location.pathname;
    if (pathname.includes('/heatmap') && from === 'aireview') {
      this.dcmQc(id);
    } else if (
      pathname.includes('/viewer/study') &&
      (from1 === 'aireview' || from1 === 'review')
    ) {
      this.dcmQc(applyImages[item.thumbIndex].dicomDrId);
    }
    if (from === 'screening') {
      window.localStorage.setItem('aiReport', '');

      const sopInstanceId = applyImages[item.thumbIndex].sopInstanceId;
      this.setState({
        thumbIndex: item.thumbIndex,
        aiReport: {},
        sopInstanceId: item.thumbIndex === 0 ? sopInstanceId : undefined,
      });
      const chestPa = applyImages[item.thumbIndex].chestPa;
      this.setRightPanelState(chestPa);
    } else if (from === 'aiproduct') {
      this.changeAIProductImageView(item.thumbIndex);
    }

    const study = this.props.studies.find(study => {
      return study.studyInstanceUid === item.studyInstanceUid;
    });

    if (!study) return;

    const displaySet = study.displaySets.find(displaySet => {
      return displaySet.displaySetInstanceUid === item.displaySetInstanceUid;
    });

    const { type } = this.state;
    if (type) this.changeAiResult(displaySet);

    this.props.setViewportSpecificData(
      this.props.activeViewportIndex,
      displaySet
    );
  };

  setRightPanelState = chestPa => {
    let [showScreening, isRightSidePanelOpen] = [!!chestPa, !!chestPa];

    let rightSidePanelDisabled = isRightSidePanelOpen ? false : true;
    this.setState({
      showScreening,
      isRightSidePanelOpen,
      isChest: chestPa,
      rightSidePanelDisabled,
    });
  };

  changeAIProductImageView = index => {
    const { from1 } = this.state;
    const applicationInfo = this.props.aiProductDetailInfo || [];
    let chestPa = applicationInfo[index].chestpa;
    if (from1 === 'aireview') chestPa = true;
    this.setRightPanelState(chestPa);
    this.setState({
      thumbIndex: index,
      studyInstanceUid: applicationInfo[index].studyUid,
      seriesInstanceUid: applicationInfo[index].seriesUid,
      sopInstanceId: applicationInfo[index].sopInstanceId,
    });

    const aiProductDetailInfo = window.store.getState().api.current
      .aiProductDetailInfo;
    const data = aiProductDetailInfo[index].ais;
    this.props.setAiProductHeatmapData(data);
  };
  //------
  setAIProductRightPanel = fn => {
    const { from1 } = this.state;
    const applicationInfo = this.props.aiProductDetailInfo || [];

    const dicomIds = [];
    for (let i = 0; i < applicationInfo.length; i++) {
      dicomIds.push(applicationInfo[i].studyDrId);
    }
    let chestPa = (applicationInfo[0] || {}).chestpa;
    if (from1 === 'aireview') chestPa = true;

    this.setRightPanelState(chestPa);
    applicationInfo[0] = applicationInfo[0] || {};
    this.setState(
      {
        dicomIds,
        applyImages: applicationInfo,
        studyInstanceUid: applicationInfo[0].studyUid,
        seriesInstanceUid: applicationInfo[0].seriesUid,
        sopInstanceId: applicationInfo[0].sopInstanceId,
        applicationInfo,
      },
      () => {
        fn && fn();
      }
    );
  };
  componentDidUpdate(prevProps) {
    const { aiProductDetailInfo, studies, userInfo } = this.props;
    if (studies !== prevProps.studies) {
      const patientId = studies[0] && studies[0].patientId;
      const currentTimepointId = this.currentTimepointId;

      this.timepointApi.retrieveTimepoints({ patientId });
      this.measurementApi.retrieveMeasurements(patientId, [currentTimepointId]);
      this.setState({ thumbnails: _mapStudiesToThumbnails(studies) });
    }

    const { from, from1, id, prewarning, applyImages } = this.state;
    //来自预警系统
    if (prewarning) {
      this.props.onUserInfoUpdated(userInfo);
    }

    const { applicationInfo, tubeStudyDetail } = this.props;

    const { pathname } = window.location;
    if (aiProductDetailInfo !== prevProps.aiProductDetailInfo) {
      this.setAIProductRightPanel(() => {
        if (pathname.includes('/heatmap') && from === 'aireview') {
          this.dcmQc(id);
        } else if (
          pathname.includes('/viewer/study') &&
          (from1 === 'aireview' || from1 === 'review')
        ) {
          if (applyImages) this.dcmQc(applyImages[0].dicomDrId);
        }
      });
    }

    if (from === 'report' && applicationInfo !== prevProps.applicationInfo) {
      const subVos = applicationInfo.subVos || [];
      const [dicomIds, selectedData, applyImages] = [[], [], []];
      for (let i = 0; i < subVos.length; i++) {
        if (subVos[i].selectFlag) {
          dicomIds.push(subVos[i].dicomDrId);
          applyImages.push(subVos[i]);
          selectedData.push({ dicomId: subVos[i].dicomDrId, adoptVO: [] });
        }
      }

      const { isRightSidePanelOpen } = this.state;
      let roleInfo = (userInfo.operationAuths || '').split(',');
      if (
        (roleInfo.includes('T') || roleInfo.includes('M')) &&
        !isRightSidePanelOpen
      ) {
        this.setState({
          isRightSidePanelOpen: false,
          rightSidePanelDisabled: false,
        });
      }

      this.setState(
        {
          dicomIds,
          selectedData,
          applyImages,
          studyInstanceUid: applicationInfo.studyUid,
          seriesInstanceUid: applyImages[0].seriesUid,
          sopInstanceId: applyImages[0].sopInstanceId,
          applicationInfo,
          isChest: applyImages[0].chestPa,
        },
        () => {
          if (pathname.includes('/heatmap') && from === 'aireview') {
            this.dcmQc(id);
          } else if (
            pathname.includes('/viewer/study') &&
            ['aireview', 'review'].includes(from1)
          ) {
            this.dcmQc(applyImages[0].dicomDrId);
          }
        }
      );
    }

    if (from === 'screening' && tubeStudyDetail !== prevProps.tubeStudyDetail) {
      const subVos = tubeStudyDetail.dicomList || [];
      const [dicomIds, selectedData, applyImages] = [[], [], []];
      for (let i = 0; i < subVos.length; i++) {
        dicomIds.push(subVos[i].dicomDrId);
        applyImages.push(subVos[i]);
        selectedData.push({ dicomId: subVos[i].dicomDrId, adoptVO: [] });
      }
      this.setState(
        {
          dicomIds,
          selectedData,
          applyImages,
          applicationInfo: tubeStudyDetail,
          isChest: applyImages[0].chestPa,
        },
        () => {
          if (pathname.includes('/heatmap')) {
            this.dcmQc(id);
          } else if (
            pathname.includes('/viewer/study') &&
            ['aireview', 'review'].includes(from1)
          ) {
            this.dcmQc(applyImages[0].dicomDrId);
          }
        }
      );
    }
  }

  aiReportChanged = () => {
    this.setState({
      aiReport: JSON.parse(window.localStorage.getItem('aiReport')),
    });
  };

  showHeatMap = (heatmap, studyUid) => {
    this.setState({
      heatmap,
      studyInstanceUid: studyUid,
      seriesInstanceUid: heatmap.seriesUid,
      sopInstanceId: heatmap.sopInstanceId,
    });
  };

  changeQC = val => {
    const { applyImages, thumbIndex, from, from1, id } = this.state;
    let get = {};
    const { pathname } = window.location;
    if (pathname.includes('/heatmap') && from === 'aireview') {
      get = { dicomDrId: id, qc: val.target.value };
    } else if (
      pathname.includes('/viewer/study') &&
      (from1 === 'aireview' || from1 === 'review')
    ) {
      get = {
        dicomDrId: applyImages[thumbIndex].dicomDrId,
        qc: val.target.value,
      };
    }

    apis.updateDcmQc(get).then(res => {
      if (res.code === '0') {
        this.setState({ QCvalue: val.target.value });
        message.success('操作成功', 2);
      } else if (res.code === '1009') {
        this.props.history.push('/login');
      }
    });
  };
  dcmQc = dicomDrId => {
    apis.dcmQc(dicomDrId).then(res => {
      if (res.code === '0') {
        this.setState({ QCvalue: res.data });
      } else if (res.code === '1009') {
        this.props.history.push('/login');
      }
    });
  };
  followupVisibleCallBack = state => {
    const [productionId, pageId] = ['101', '10022'];
    const [moduleId, elementId] = ['mk0001', 'ns-002'];
    eventListener({ productionId, pageId, moduleId, elementId });
    this.setState({ followupVisible: state });

    this.props.followupVisibleCallBack(state);
  };

  handleSidePanelChange = (side, selectedPanel) => {
    const sideClicked = side && side[0].toUpperCase() + side.slice(1);
    const openKey = `is${sideClicked}SidePanelOpen`;
    const selectedKey = `selected${sideClicked}SidePanel`;
    const updatedState = Object.assign({}, this.state);

    const isOpen = updatedState[openKey];
    const prevSelectedPanel = updatedState[selectedKey];
    // RoundedButtonGroup returns `null` if selected button is clicked
    const isSameSelectedPanel =
      prevSelectedPanel === selectedPanel || selectedPanel === null;

    updatedState[selectedKey] = selectedPanel || prevSelectedPanel;

    const isClosedOrShouldClose = !isOpen || isSameSelectedPanel;
    if (isClosedOrShouldClose) updatedState[openKey] = !updatedState[openKey];

    this.setState(updatedState);
  };
  render() {
    const { from, from1, isLeftSidePanelOpen } = this.state;
    const { selectedLeftSidePanel } = this.state;
    let VisiblePanelLeft, VisiblePanelRight;
    const panelExtensions = extensionManager.modules[MODULE_TYPES.PANEL];
    panelExtensions.forEach(panelExt => {
      panelExt.module.components.forEach(comp => {
        if (comp.id === this.state.selectedRightSidePanel) {
          VisiblePanelRight = comp.component;
        } else if (comp.id === selectedLeftSidePanel) {
          VisiblePanelLeft = comp.component;
        }
      });
    });
    const radioStyle = { display: 'block', height: '30px' };
    const { pathname } = window.location;
    const qcFlag1 =
      pathname.includes('/viewer/study') &&
      ['aireview', 'review'].includes(from1);
    const qcFlag2 = pathname.includes('/heatmap') && from === 'aireview';

    const { isRightSidePanelOpen, selectedRightSidePanel } = this.state;
    return (
      <>
        {/* TOOLBAR */}
        <ConnectedToolbarRow
          resource={this.props.resource}
          isLeftSidePanelOpen={isLeftSidePanelOpen}
          isRightSidePanelOpen={isRightSidePanelOpen}
          rightSidePanelDisabled={this.state.rightSidePanelDisabled}
          selectedLeftSidePanel={
            isLeftSidePanelOpen ? selectedLeftSidePanel : ''
          }
          selectedRightSidePanel={
            isRightSidePanelOpen ? selectedRightSidePanel : ''
          }
          followupLen={this.props.followupLen}
          followupVisibleCallBack={this.followupVisibleCallBack}
          handleSidePanelChange={(side, selectedPanel) =>
            this.handleSidePanelChange(side, selectedPanel)
          }
          applicationInfo={this.state.applicationInfo}
        />

        {/*<ConnectedStudyLoadingMonitor studies={this.props.studies} />*/}
        {/*<StudyPrefetcher studies={this.props.studies} />*/}
        <ConnectedHeatmapLoader
          aiReportSelected={this.state.aiReport}
          dicomIds={this.state.dicomIds}
          thumbIndex={this.state.thumbIndex}
          studyInstanceUid={this.state.studyInstanceUid}
          seriesInstanceUid={this.state.seriesInstanceUid}
          sopInstanceId={this.state.sopInstanceId}
          heatmap={this.state.heatmap}
        />

        {/* VIEWPORTS + SIDEPANELS */}
        <div className="FlexboxLayout">
          {/* LEFT */}
          <SidePanel from="left" isOpen={isLeftSidePanelOpen}>
            {VisiblePanelLeft && (
              <VisiblePanelLeft
                viewports={this.props.viewports}
                activeIndex={this.props.activeViewportIndex}
                studies={this.state.thumbnails}
                onThumbnailClick={this.onThumbnailClick}
                followupVisible={this.state.followupVisible}
              />
            )}
          </SidePanel>

          {/* MAIN */}
          <div className={classNames('main-content')}>
            <ConnectedViewerMain
              studies={this.props.studies}
              sopInstanceId={this.state.sopInstanceId}
              userInfo={this.props.userInfo}
            />

            {(this.state.isChest && qcFlag1) || qcFlag2 ? (
              <div className="qualityBox">
                <div>影像质量评价</div>
                <Radio.Group
                  onChange={this.changeQC}
                  value={this.state.QCvalue}
                >
                  <Radio style={radioStyle} value={true}>
                    合格
                  </Radio>
                  <Radio style={radioStyle} value={false}>
                    不合格
                  </Radio>
                </Radio.Group>
              </div>
            ) : null}
          </div>

          {/* RIGHT */}
          <SidePanel from="right" isOpen={this.state.isRightSidePanelOpen}>
            {VisiblePanelRight && (
              <VisiblePanelRight
                viewports={this.props.viewports}
                activeIndex={this.props.activeViewportIndex}
                studies={this.state.thumbnails}
                aiReportChanged={this.aiReportChanged}
                dicomIds={this.state.dicomIds}
                selectedData={this.state.selectedData}
                showHeatMap={this.showHeatMap}
                showScreening={this.state.showScreening}
                detailList4StudyImgList={this.props.detailList4StudyImgList}
                tubeStudyDetail={this.props.tubeStudyDetail}
                applicationInfo={this.props.applicationInfo}
                followupList={this.props.followupList}
              />
            )}
          </SidePanel>
        </div>
        <ConnectedLabellingOverlay />
      </>
    );
  }
}

export default Viewer;

/**
 * What types are these? Why do we have "mapping" dropped in here instead of in
 * a mapping layer?
 *
 * TODO[react]:
 * - Add sorting of display sets
 * - Add showStackLoadingProgressBar option
 *
 * @param {Study[]} studies
 * @param {DisplaySet[]} studies[].displaySets
 */
const _mapStudiesToThumbnails = function(studies) {
  return studies.map(study => {
    const { studyInstanceUid } = study;
    const thumbnails = study.displaySets.map((displaySet = {}) => {
      const {
        displaySetInstanceUid,
        seriesDescription,
        seriesNumber,
        instanceNumber,
        numImageFrames,
      } = displaySet;

      let imageId;
      let altImageText;
      if (displaySet.modality && displaySet.modality === 'SEG') {
        // TODO: We want to replace this with a thumbnail showing
        // the segmentation map on the image, but this is easier
        // and better than what we have right now.
        altImageText = 'SEG';
      } else if (displaySet.images && displaySet.images.length) {
        const imageIndex = Math.floor(displaySet.images.length / 2);

        imageId = displaySet.images[imageIndex].getImageId();
      } else {
        altImageText = displaySet.modality ? displaySet.modality : 'UN';
      }

      return {
        imageId,
        altImageText,
        displaySetInstanceUid,
        seriesDescription,
        seriesNumber,
        instanceNumber,
        numImageFrames,
        date: displaySet.studyDate,
      };
    });

    return { studyInstanceUid, thumbnails, date: study.studyDate };
  });
};
